<template>
  <router-link class="see-more" :to="path">查看更多</router-link>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.see-more {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  background-color: #3c3a42;
  color: #c3c2c4;
  text-decoration: none;
  &:after {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../assets/img/arrowRight.svg') no-repeat;
    background-size: cover;
  }
}
</style>

